const elementVisible = (element: HTMLElement): boolean => {
  const bounding = element.getBoundingClientRect();
  const myElementHeight = element.offsetHeight;
  const myElementWidth = element.offsetWidth;

  return (bounding.top >= -myElementHeight
    && bounding.left >= -myElementWidth
    && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth
    && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight);
};

const lazyLoadImage = (element: HTMLElement) => {
  if (!elementVisible(element)) {
    return;
  }

  const backgroundElementSrc = element.getAttribute("lazy-bg-src")
  if (backgroundElementSrc) {
    element.style.backgroundImage = `url(${element.getAttribute("lazy-bg-src")})`
    return;
  }

  const elementSrc = element.getAttribute("lazy-src");
  if (elementSrc) {
    element.setAttribute('src', elementSrc);
  }
}

const lazyLoadImages = (root: Document | Element) => {
  const elements = root.querySelectorAll('[lazy-src], [lazy-bg-src]');
  (elements as NodeListOf<HTMLElement>).forEach(lazyLoadImage);
};


document.addEventListener('DOMContentLoaded', () => {
  lazyLoadImages(document);
  document.addEventListener('scroll', () => lazyLoadImages(document));
  const elements = document.querySelectorAll('[lazy-scroll]');
  (elements as NodeListOf<HTMLElement>).forEach((element) => {
    element.addEventListener('scroll', () => lazyLoadImages(element));
  });
});
